// extracted by mini-css-extract-plugin
module.exports = {"root":"Goals_root__UXzYx","header":"Goals_header__3ngfO","placeholder":"Goals_placeholder__1M7g1"};